import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wkanh686mb: FaireBrandEntity = {
  token: "b_wkanh686mb",
  type: "brand",
  name: "Luxiny Products - Luxurious Bath and Body",
  avatarUrl:
    "https://cdn.faire.com/fastly/80eeb621c90eb4579c70115e366fe496e97b16e1fe97724350ae40c65ad4e475.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7b96ca18cfbd7bd96baece91e6e7ff6d05790f735cd4d1f25e3d4a18156cd6a0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/80eeb621c90eb4579c70115e366fe496e97b16e1fe97724350ae40c65ad4e475.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7b96ca18cfbd7bd96baece91e6e7ff6d05790f735cd4d1f25e3d4a18156cd6a0.png",
  location: "Kimball township, MI, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 125,
  isTopShop: true,
  isInsider: true,
  description:
    "At Luxiny, we craft high-quality beauty and wellness products using natural, plant-based ingredients and essential oils. Our handmade collection—featuring bath bombs, shower steamers, bath salts, coconut milk soaks, foaming hand soaps, and shampoo bars—nourishes skin and hair while delivering a luxurious spa experience at home.\n\nProudly made in the USA, Luxiny products are vegan, eco-friendly, and packaged to reduce plastic waste. Free from harsh chemicals, our formulas are gentle yet effective—perfect for spring, summer, fall 2025, and Christmas 2025 gifts. We carefully source every ingredient for sustainability and safety, appealing to conscious consumers seeking clean beauty.\n\nRetailers love our vibrant, gift-ready seasonal collections that brighten bath time and inspire self-care. Bestselling shower steamers and detangling hair bars are top picks for travel, daily refreshment, and thoughtful gifting. Each product is designed to create memorable experiences that build customer loyalty.\n\nAs a women-owned brand, Luxiny offers clean packaging and small-batch quality customers trust. Whether stocking seasonal favorites or year-round essentials, we help retailers meet the growing demand for clean, sustainable beauty. Luxuriously affordable. Handmade in the USA.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:58.639Z",
    importedBy: "entity-db-cli",
  },
};
